import { useCallback, useEffect, useMemo, useState } from "react";
import { apiFetch } from "../api";

export function useApps(token) {
  const [apps, setApps] = useState([]);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    try {
      const data = await apiFetch("/api/apps", { silent: true }, token);
      setApps(data.apps || []);
      setError("");
    } catch (requestError) {
      setError(requestError?.message || "앱 목록을 불러오지 못했습니다.");
    }
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);

  const visibleApps = useMemo(() => apps.filter(app => !app.hidden), [apps]);
  return { apps, setApps, visibleApps, error, refresh };
}
